import camelCase from 'lodash-es/camelCase';

var namespacer = '/';

export default (function (type) {
  return type.indexOf(namespacer) === -1 ? camelCase(type) : type.split(namespacer).map(camelCase).join(namespacer);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/utils/camelCase.js
// module id = 552
// module chunks = 7